module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("CONTENTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("For Want of a Hat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Kate Dane")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Not on Our Watch")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Kevin Ikenberry")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("3. ")]), _c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Syracuse, the Eternal City")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Stephen K. Stein and Carolyn Ivy Stein")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("4. ")]), _c('a', {
    attrs: {
      "href": "#/chapter004"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Doom of Egypt")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Julia V. Ashley")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("5. ")]), _c('a', {
    attrs: {
      "href": "#/chapter005"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Divine Calm")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Charles E. Gannon")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("6. ")]), _c('a', {
    attrs: {
      "href": "#/chapter006"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("A Ruinous Rent")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("L. A. Selby")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("7. ")]), _c('a', {
    attrs: {
      "href": "#/chapter007"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("A Brother’s Oath")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("L. Briar")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("8. ")]), _c('a', {
    attrs: {
      "href": "#/chapter008"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Xiào Shùn")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Lehua Parker")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("9. ")]), _c('a', {
    attrs: {
      "href": "#/chapter009"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Kutuzov at Gettysburg")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("B. Daniel Blatt")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("10. ")]), _c('a', {
    attrs: {
      "href": "#/chapter010"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Notorious Lawman Billy the Kid")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Edward J. Knight")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("11. ")]), _c('a', {
    attrs: {
      "href": "#/chapter011"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Out of Habit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Julie Jones")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("12. ")]), _c('a', {
    attrs: {
      "href": "#/chapter012"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Aces High")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Jennifer M. Roberts")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("13. ")]), _c('a', {
    attrs: {
      "href": "#/chapter013"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Rufus and the Wizard of Wireless")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Stace Johnson")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("14. ")]), _c('a', {
    attrs: {
      "href": "#/chapter014"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("G-Gals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Kendrai Meeks")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("15. ")]), _c('a', {
    attrs: {
      "href": "#/chapter015"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Collateral Loss")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Fulvio Gatti")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("16. ")]), _c('a', {
    attrs: {
      "href": "#/chapter016"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Boulder Choke")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Carrie Callahan")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("17. ")]), _c('a', {
    attrs: {
      "href": "#/chapter017"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("This Was Your Life (Play It Again, Sam)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Mary Pletsch")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("18. ")]), _c('a', {
    attrs: {
      "href": "#/chapter018"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Unnamed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Gama Ray Martinez")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("19. ")]), _c('a', {
    attrs: {
      "href": "#/chapter019"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Three Times the Power, Four Times the Pain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Akis Linardos")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("20. ")]), _c('a', {
    attrs: {
      "href": "#/chapter020"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Entropy Ranch")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-content toc-item-subtitle"
  }, [_vm._v("Kevin J. Anderson")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheeditor"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("About the Editor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ifyouliked"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("If You Liked …")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/otherwordfirepresstitleseditedbylisamangum"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Other WordFire Press Titles Edited by Lisa Mangum")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0